import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  FormControlLabel,
  Checkbox,
  createTheme,
  Tooltip,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteMailing,
  getMailingById,
  postMailing,
  updateMailing,
} from "../../../../api/mailing";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import MultiTabBlock from "../../../components/MultiTabBlock";
import { getNoticias } from "../../../../api/noticia";
import { formatDateForInput, getNonEmpty } from "../../../../utils/helpers";
import Table, { buttonsStyle } from "../../../components/tables/table";
import {
  Delete,
  Edit,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";
import { shallowEqual, useSelector } from "react-redux";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import NewsTableDialog from "../../../components/dialogs/NewsTableDialog";
import { getUserTypes } from "../../../../api/userType";
import UserTypesTableDialog from "../../../components/dialogs/UserTypesTableDialog";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyMailing() {
  return {
    noticias: [],
    userTypes: [],
    active: true,
  };
}

export default function EditMailingPage() {
  const [mailing, setMailing] = useState(getEmptyMailing());
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [noticias, setNoticias] = useState([]);
  const [noticiaId, setNoticiaId] = useState(null);
  const [userTypes, setUserTypes] = useState([]);
  const [userTypeId, setUserTypeId] = useState(null);
  const [openNoticiasDialogo, setOpenNoticiasDialogo] = useState(false);
  const [openUserTypesDialogo, setOpenUserTypesDialogo] = useState(false);
  const [refreshOrder, setRefreshOrder] = useState(false);
  const mailingId = useParams().id;
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resUserTypes = await getUserTypes();
        if (resUserTypes.status === 200) {
          setUserTypes(resUserTypes.data);
        }
        const resNoticias = await getNoticias();
        if (resNoticias.status === 200) {
          setNoticias(resNoticias.data);
        }
        if (!mailingId) {
          disableLoadingData();
          return;
        }
        getMailingById(mailingId)
          .then((res) => {
            if (res.status === 200) {
              const user = res.data;
              delete user.password;
              setMailing(user);

              disableLoadingData();
            }
          })
          .catch((error) => {
            alertError({
              error: error,
              customMessage: "Could not get mailing.",
            });
            history.push("/mailings");
          });
      } catch (error) {}
    };
    fetchData();
  }, [mailingId, disableLoadingData, history]);
  useEffect(() => {
    console.log(mailing);
  }, [mailing]);

  function saveMailing() {
    let saveMailing = mailing;
    saveMailing.noticias = saveMailing.noticias.map((noticia) => {
      const { _id, ...rest } = noticia;
      return rest;
    });

    if (!mailingId) {
      postMailing(saveMailing)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "Saved!",
              customMessage: "Mailing successfully created.",
            });
            history.push("/mailings");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save mailing.",
          });
        });
    } else {
      updateMailing(mailingId, saveMailing)
        .then((res) => {
          if (res.status === 200) {
            alertSuccess({
              title: "Saved!",
              customMessage: "Changes successfully saved.",
            });
            history.push("/mailings");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save changes.",
          });
        });
    }
  }

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === " ") return;

      if (!mailing[element]) mailing[element] = {};
      let newText = mailing[element];
      newText[lang] = event.target.value;
      setMailing({ ...mailing, [element]: newText });
    } else setMailing({ ...mailing, [element]: event.target.value });
  };

  const renderMultilanguageTabContent = (lang) => {
    return (
      <>
        <TextField
          id={`asunto`}
          label="Asunto"
          value={
            mailing.asunto && mailing.asunto[lang] ? mailing.asunto[lang] : ""
          }
          onChange={handleChange("asunto", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
        />
      </>
    );
  };
  const renderContentDatosGenerales = () => {
    return (
      <>
        <MultilanguageTabBlock
          multilanguageTabContent={renderMultilanguageTabContent}
        />
        <div className="d-flex">
          <div className="col-md-4">
            <TextField
              id={`fechaEnvio`}
              label="Fecha de envío"
              value={
                mailing.fechaEnvio ? formatDateForInput(mailing.fechaEnvio) : ""
              }
              onChange={handleChange("fechaEnvio")}
              InputLabelProps={{
                shrink: true,
              }}
              type="datetime-local"
              margin="normal"
              variant="outlined"
              required
            />
          </div>
        </div>
        <br />
        <FormControlLabel
          control={
            <Checkbox
              checked={mailing.active}
              onChange={() =>
                setMailing({ ...mailing, active: !mailing.active })
              }
              name="checkActive"
            />
          }
          label="Active"
        />
      </>
    );
  };

  useEffect(() => {
    setRefreshOrder(false);
  }, [refreshOrder]);

  const renderContentNoticias = () => {
    function getData() {
      let data = [];
      const noticiasMail = mailing?.noticias;
      for (const noti of noticiasMail) {
        let elem = {};
        elem.title = getNonEmpty(
          noticias.find((x) => x._id === noti.noti)?.titulo
        );
        elem.order = noti?.order;
        elem.id = noti?._id;
        elem.mailingId = mailing._id;
        data.push(elem);
      }
      data.sort((a, b) => a.order - b.order);
      return data;
    }
    function buttonFormatter(cell) {
      const elem = mailing?.noticias.find((item) => item._id === cell);

      const handleSubtract = () => {
        setMailing((prevMailing) => {
          const currentNoticia = prevMailing.noticias.find(
            (noti) => noti._id === cell
          );
          if (!currentNoticia || currentNoticia.order === 0) return prevMailing;

          const newOrder = currentNoticia.order - 1;
          const noticiaToSwap = prevMailing.noticias.find(
            (noti) => noti.order === newOrder
          );

          return {
            ...prevMailing,
            noticias: prevMailing.noticias.map((noti) => {
              if (noti._id === cell) {
                return { ...noti, order: newOrder };
              }
              if (noticiaToSwap && noti._id === noticiaToSwap._id) {
                return { ...noti, order: currentNoticia.order };
              }
              return noti;
            }),
          };
        });
        setRefreshOrder(true);
      };

      const handleAdd = () => {
        setMailing((prevMailing) => {
          const currentNoticia = prevMailing.noticias.find(
            (noti) => noti._id === cell
          );
          if (
            !currentNoticia ||
            currentNoticia.order === prevMailing.noticias.length - 1
          )
            return prevMailing;

          const newOrder = currentNoticia.order + 1;
          const noticiaToSwap = prevMailing.noticias.find(
            (noti) => noti.order === newOrder
          );

          return {
            ...prevMailing,
            noticias: prevMailing.noticias.map((noti) => {
              if (noti._id === cell) {
                return { ...noti, order: newOrder };
              }
              if (noticiaToSwap && noti._id === noticiaToSwap._id) {
                return { ...noti, order: currentNoticia.order };
              }
              return noti;
            }),
          };
        });
        setRefreshOrder(true);
      };

      return (
        <>
          {user?.role === "admin" ||
            (user.role === "gestor" && (
              <>
                <Tooltip title={"Up"}>
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={handleSubtract}
                    disabled={elem?.order === 0}
                  >
                    <KeyboardArrowUp />
                  </Button>
                </Tooltip>
                <Tooltip title={"Down"}>
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={handleAdd}
                    disabled={elem?.order === mailing?.noticias?.length - 1}
                  >
                    <KeyboardArrowDown />
                  </Button>
                </Tooltip>
                <Tooltip title="Edit">
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                      history.push("/edit-noticia/" + elem.noti);
                    }}
                  >
                    <Edit />
                  </Button>
                </Tooltip>

                <Tooltip title="Delete">
                  <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                      setNoticiaId(cell);
                      setOpenConfirmDialog(3);
                    }}
                  >
                    <Delete />
                  </Button>
                </Tooltip>
              </>
            ))}
        </>
      );
    }

    const columns = [
      { dataField: "title", text: "Título", sort: true },
      { dataField: "id", text: "", formatter: buttonFormatter },
    ];
    return (
      <>
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              setOpenNoticiasDialogo(true);
            }}
          >
            Add
          </button>
        </div>
        {!refreshOrder && <Table data={getData()} columns={columns} />}
      </>
    );
  };
  const renderContentUserTypes = () => {
    function getData() {
      let data = [];
      const userTypesMail = mailing?.userTypes;
      for (const userType of userTypesMail) {
        let elem = {};
        elem.titulo = userTypes.find((x) => x._id === userType)?.titulo;
        elem.id = userType?._id;
        data.push(elem);
      }
      return data;
    }
    function buttonFormatter(cell) {
      return (
        <>
          {(user?.role === "admin" || user.role === "gestor") && (
            <>
              <Tooltip title="Delete">
                <Button
                  style={buttonsStyle}
                  size="small"
                  onClick={() => {
                    setUserTypeId(cell);
                    setOpenConfirmDialog(4);
                  }}
                >
                  <Delete />
                </Button>
              </Tooltip>
            </>
          )}
        </>
      );
    }

    const columns = [
      { dataField: "titulo", text: "Título", sort: true },
      { dataField: "id", text: "", formatter: buttonFormatter },
    ];
    return (
      <>
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              setOpenUserTypesDialogo(true);
            }}
          >
            Add
          </button>
        </div>
        {!refreshOrder && <Table data={getData()} columns={columns} />}
      </>
    );
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          <CardHeader title="Editar Mailing"></CardHeader>
          <CardBody>
            <MultiTabBlock
              tabs={[
                {
                  enable: true,
                  title: "Datos Generales",
                  renderContent: renderContentDatosGenerales,
                },
                {
                  enable: true,
                  title: "Modulos",
                  renderContent: renderContentNoticias,
                },
                {
                  enable: true,
                  title: "Tipos de Usuarios",
                  renderContent: renderContentUserTypes,
                },
              ]}
            />
          </CardBody>
        </Card>
        <Button
          onClick={() => history.push("/mailings")}
          variant="outlined"
          style={{ marginRight: "20px" }}
        >
          Back
        </Button>
        <Button
          onClick={() => saveMailing()}
          variant="outlined"
          color="primary"
          style={{ marginRight: "20px" }}
        >
          Save mailing
        </Button>
        <NewsTableDialog
          title="Noticias"
          open={openNoticiasDialogo}
          setOpen={setOpenNoticiasDialogo}
          data={noticias.filter(
            (x) => !mailing?.noticias?.some((y) => y.noti === x._id)
          )}
          onSelectRow={(noticiaId) => {
            let mailingNoticias = mailing.noticias;
            mailingNoticias.push({
              _id: mailingNoticias.length || 0,
              noti: noticiaId,
              order: mailingNoticias.length || 0,
            });

            setMailing({ ...mailing, noticias: mailingNoticias });
            setRefreshOrder(true);
          }}
        />
        <UserTypesTableDialog
          title="Tipos de Usuarios"
          open={openUserTypesDialogo}
          setOpen={setOpenUserTypesDialogo}
          data={userTypes.filter(
            (x) => !mailing?.userTypes?.some((y) => y === x._id)
          )}
          onSelectRow={(userTypeId) => {
            let mailingUserTypes = mailing.userTypes;
            mailingUserTypes.push(userTypeId);

            setMailing({ ...mailing, userTypes: mailingUserTypes });
            setRefreshOrder(true);
          }}
        />
        <ConfirmDialog
          title={"Are you sure you want to delete this news?"}
          open={openConfirmDialog === 3}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            setMailing({
              ...mailing,
              noticias: mailing?.noticias?.filter((x) => x._id !== noticiaId),
            });
            setRefreshOrder(true);
          }}
        />
        <ConfirmDialog
          title={"Are you sure you want to delete this user type?"}
          open={openConfirmDialog === 4}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            setMailing({
              ...mailing,
              userTypes: mailing?.userTypes?.filter(
                (x) => x._id !== userTypeId
              ),
            });
            setRefreshOrder(true);
          }}
        />
        {mailingId && (
          <>
            <MuiThemeProvider theme={theme}>
              <Button
                onClick={() => setOpenConfirmDialog(true)}
                variant="outlined"
                color="secondary"
              >
                Delete mailing
              </Button>
            </MuiThemeProvider>

            <ConfirmDialog
              title={"Are you sure you want to delete this mailing?"}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                deleteMailing(mailingId)
                  .then((res) => {
                    if (res.status === 204 || res.status === 200) {
                      alertSuccess({
                        title: "Deleted!",
                        customMessage: "Mailing deleted successfully",
                      });
                      history.push("/mailings");
                    }
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: "Could not delete mailing.",
                    });
                  });
              }}
            />
          </>
        )}
      </>
    );
}
